// @flow

const googleMapsApiKey = "AIzaSyDtudn5csi3NKmob1Naw7hsdmt743vKcDM"
const googleAnalyticsTrackingId = "G-QK1KPXV7HH"

const HERE_MAPS_API_KEY = "R2MOKNXS2AGZHQ9IqFTKaRunK1ZJ1xM4oipaM81-tCY"

const hereMapsSettings = {
  apikey: HERE_MAPS_API_KEY
}

const NEWS_TARGETS = {
  TRANSPORTER_ADMINS: "TRANSPORTER_ADMINS",
  DRIVERS: "DRIVERS"
}

export {
  googleMapsApiKey,
  googleAnalyticsTrackingId,
  hereMapsSettings,
  HERE_MAPS_API_KEY,
  NEWS_TARGETS
}

export const fleetRegions: { [string]: string } = {
  SWEDEN_REGION_STOCKHOLM: "SWEDEN_REGION_STOCKHOLM",
  SWEDEN_REGION_SOUTH: "SWEDEN_REGION_SOUTH",
  SWEDEN_REGION_WEST: "SWEDEN_REGION_WEST",
  SWEDEN_REGION_EAST: "SWEDEN_REGION_EAST",
  SWEDEN_REGION_NORTH: "SWEDEN_REGION_NORTH"
}

export const FLEET_REGION_NAMES: { [string]: string } = {
  [fleetRegions.SWEDEN_REGION_EAST]: "SE-Mid",
  [fleetRegions.SWEDEN_REGION_NORTH]: "SE-North",
  [fleetRegions.SWEDEN_REGION_SOUTH]: "SE-South",
  [fleetRegions.SWEDEN_REGION_STOCKHOLM]: "SE-Stockholm",
  [fleetRegions.SWEDEN_REGION_WEST]: "SE-West"
}
